var external = {
  // eslint-disable-next-line no-console
  logger: console.log
};

var provideLayerManipulations = function provideLayerManipulations(functions) {
  Object.assign(external, functions);
};

var getLayerManipulations = function getLayerManipulations() {
  return external;
};

export { getLayerManipulations, provideLayerManipulations };
